exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#inactive-report-source-profile-alerts .banner.experian{width:96%;max-width:1440px}@media (min-width:768px){#inactive-report-source-profile-alerts .banner{height:140px}}@media (max-width:768px){#inactive-report-source-profile-alerts .banner{height:215px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/rspSignupPrompts/report_source_profiles/experian/experian.css
// module id = 471
// module chunks = 0